import type { SpaceResource } from "@octopusdeploy/octopus-server-client";
import { projectsRoute } from "@octopusdeploy/portal-routes";
import MissingImportExportPermissionCallout from "app/areas/projects/components/ImportExport/MissingImportExportPermissionCallout";
import * as React from "react";
import { ProjectPageLayout } from "~/areas/projects/components/ProjectPageLayout";
import Tasks from "~/areas/tasks/components/Tasks/Tasks";
import { repository, session } from "~/clientInstance";
import ActionList from "~/components/ActionList";
import AreaTitle from "~/components/AreaTitle";
import { ContextualHelpLayout } from "~/components/ContextualHelpLayout/ContextualHelpLayout";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import DataBaseComponent from "~/components/DataBaseComponent";
import { PageHeaderPrimary } from "~/components/PageHeaderPrimary";
import { useIsPageHeaderVNextEnabled } from "~/components/RootRoutes/useIsPageHeaderVNextEnabled";
import ImportExportMenu, { importExportMenuItems } from "./ImportExportMenu";
import styles from "./style.module.less";
interface ImportExportTasksInternalProps extends ImportExportTasksProps {
    isPageHeaderVNextEnabled: boolean;
}
interface ImportExportTasksState extends DataBaseComponentState {
    space?: SpaceResource;
}
class ImportExportTasksInternal extends DataBaseComponent<ImportExportTasksInternalProps, ImportExportTasksState> {
    constructor(props: ImportExportTasksInternalProps) {
        super(props);
        this.state = {};
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            if (!repository.spaceId) {
                throw new Error("Attempted to render ImportExportTasks in a system context. This should never happen.");
            }
            const [space] = await Promise.all([repository.Spaces.get(repository.spaceId)]);
            this.setState({
                space,
            });
        });
    }
    isSpaceManager(): boolean {
        if (!session.currentPermissions) {
            throw new Error("Attempted to access the current user's permissions, but they weren't found. This should never happen.");
        }
        return this.state.space !== undefined && session.currentPermissions.isSpaceManager(this.state.space);
    }
    render() {
        const isSpaceManager = this.isSpaceManager();
        const overflowMenu = <ImportExportMenu />;
        return (<main>
                {!this.props.isPageHeaderVNextEnabled && (<AreaTitle title="Projects" link={projectsRoute.generateUrl({ spaceId: this.props.spaceId })}>
                        <ActionList actions={[overflowMenu]}/>
                    </AreaTitle>)}
                <ContextualHelpLayout>
                    {this.props.isPageHeaderVNextEnabled && (<PageHeaderPrimary title="Import/Export Tasks" navUpLink={{ label: "Projects", linkHref: projectsRoute.generateUrl({ spaceId: this.props.spaceId }) }} overflowActions={importExportMenuItems}/>)}
                    <div className={this.props.isPageHeaderVNextEnabled ? styles.containerVNext : styles.container}>
                        <Tasks renderLayout={(layoutProps) => (<ProjectPageLayout title={this.props.isPageHeaderVNextEnabled ? undefined : "Import/Export Tasks"} busy={layoutProps.busy} errors={this.errors} fullWidth={true}>
                                    {this.state.space && !isSpaceManager && <MissingImportExportPermissionCallout />}
                                    {this.state.space && isSpaceManager && (<>
                                            <div className={styles.layoutContainer}>{layoutProps.children}</div>
                                        </>)}
                                </ProjectPageLayout>)} restrictToTaskTypes={["ExportProjects", "ImportProjects"]} hideAdvancedFilters={true}/>
                    </div>
                </ContextualHelpLayout>
            </main>);
    }
    static displayName = "ImportExportTasksInternal";
}
interface ImportExportTasksProps {
    spaceId: string;
}
function ImportExportTasks(props: ImportExportTasksProps) {
    const isPageHeaderVNextEnabled = useIsPageHeaderVNextEnabled();
    return <ImportExportTasksInternal {...props} isPageHeaderVNextEnabled={isPageHeaderVNextEnabled}/>;
}
export default ImportExportTasks;
